export default {
    setList(state, list) {
        state.list = list.data;
    },
    setAccount(state, data) {
        state.account = data;
    },
    clear(state) {
        state.account = null;
    }
}
